var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.509277 7.07009C0.509277 3.16021 3.75542 0 7.68197 0C11.6196 0 14.8657 3.16021 14.8657 7.07009C14.8657 9.04034 14.1538 10.8695 12.9821 12.4198C11.6894 14.13 10.0961 15.62 8.30276 16.7896C7.8923 17.0599 7.52188 17.0803 7.0714 16.7896C5.2678 15.62 3.67453 14.13 2.39293 12.4198C1.22033 10.8695 0.509277 9.04034 0.509277 7.07009ZM5.31813 7.29009C5.31813 8.5999 6.38002 9.63007 7.68206 9.63007C8.98495 9.63007 10.0571 8.5999 10.0571 7.29009C10.0571 5.99048 8.98495 4.91016 7.68206 4.91016C6.38002 4.91016 5.31813 5.99048 5.31813 7.29009Z",
    fill: "#030229"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a024062eb9896f1e62360de14d923e1e.svg";
export { ForwardRef as ReactComponent };